import isNil from "lodash/isNil";
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import { isImmutable } from "immutable";

import { CREATE_VIEW_GROUPS_FORM } from "features/planner/planner.constants";

import { WORK_SCHEDULE_OVERRIDE_FORM } from "features/planner/employee/employee.constants";

// utils
export const required = value =>
  isString(value)
    ? isEmpty(value)
    : isImmutable(value)
    ? value.isEmpty()
    : isNil(value);

export const notEmpty = value => (isNil(value) ? true : !value.size);

// forms
export const validateCreateViewGroupsForm = values => {
  const errors = {};

  if (!values.size) return errors;

  if (!values.get(CREATE_VIEW_GROUPS_FORM.SELECTED_ITEMS).size) {
    errors[CREATE_VIEW_GROUPS_FORM.SELECTED_ITEMS] = "Invalid";
  }

  return errors;
};

export const validateWorkScheduleOverrideForm = values => {
  const errors = {};

  if (!values.size) return errors;

  if (!values.get(WORK_SCHEDULE_OVERRIDE_FORM.START_DATE)) {
    errors[WORK_SCHEDULE_OVERRIDE_FORM.START_DATE] = "Invalid date";
  }

  if (!values.get(WORK_SCHEDULE_OVERRIDE_FORM.END_DATE)) {
    errors[WORK_SCHEDULE_OVERRIDE_FORM.END_DATE] = "Invalid date";
  }

  return errors;
};

export const validateMarkerForm = values => {
  let required = false;

  if (!values || !values.size) {
    required = true;
  } else {
    // marker file must be size less than 4000
    if (values.first().size > 4000) {
      required = true;
    }
  }

  return required;
};

export const isSearchTermValid = (searchTerm = "") =>
  !isEmpty(searchTerm.trim());
